import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { PermalinkService } from "../services/permalink.service";
import { BusinessService } from "../services/business.service";
import { SessionStorageService } from "../services/session-storage.service";
import { APPLICATION_ROUTES } from "../constants/app-routes";
import { LOCAL_STORAGE } from "../../shared/constants/local-storage.constants";
import { SESSION_STORAGE } from "../../shared/constants/session-storage.constants";

@Injectable({ providedIn: "root" })
export class PermalinkGuard implements CanActivate {

  constructor(
    private router: Router,
    private permalinkService: PermalinkService,
    private businessService: BusinessService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const utmId = route.paramMap.get("utmId");
    const restaurantName = route.paramMap.get("restaurantName");

    console.log("PermalinkGuard firing:", { restaurantName, utmId });

    if (!utmId || !restaurantName) {
      this.router.navigate([`/${APPLICATION_ROUTES.BASE_URL}`]);
      return of(false);
    }

    return this.permalinkService.resolvePermalink(restaurantName, utmId).pipe(
      map(({ merchantId, businessId, businessDetails, utmParams }) => {
        console.log("PermalinkGuard resolved:", { merchantId, businessId });

        SessionStorageService.setValue(SESSION_STORAGE.MERCHANT_ID, merchantId);
        SessionStorageService.setValue(SESSION_STORAGE.BUSINESSID, businessId);

        if (utmParams) {
          localStorage.setItem(
            LOCAL_STORAGE.UTMID,
            utmParams.utmId
          );
          console.log("get UTM ID:", utmParams);
          console.log("get UTM ID:", localStorage.getItem(LOCAL_STORAGE.UTMID));
        }

        this.businessService.setBusiness(businessDetails);
        this.permalinkService.setResolvedByGuard(true);

        // ✅ NO router.navigate — URL stays as /simpayx/test/HDg72
        // ✅ return true — PickUpPageModule loads on current URL
        return true;
      }),
      catchError((error) => {
        console.error("Permalink resolution failed:", error);
        this.router.navigate([`/${APPLICATION_ROUTES.BASE_URL}`]);
        return of(false);
      })
    );
  }
}